import { render, staticRenderFns } from "./TimeSliderSettings.vue?vue&type=template&id=514303a8"
import script from "./TimeSliderSettings.vue?vue&type=script&lang=js"
export * from "./TimeSliderSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports